import { Component, h, Prop, Host } from '@stencil/core';
import { open_in_new } from 'pn-design-assets/pn-assets/icons.js';

@Component({
  tag: 'pn-product-card-price',
  styleUrl: 'pn-product-card-price.scss',
})
export class PnProductCardPrice {
  @Prop() label: string;
  @Prop() amount: string;
  @Prop() currency: string;
  @Prop() note: string;
  @Prop() url: string;
  @Prop() service: string;
  @Prop() linkid: string;

  render() {
    if (!this.amount) {
      return;
    }
    return this.url ? (
      <Host id={this.linkid}>
        <div class="price">
          {this.amount ? <span>{this.amount}</span> : null}
          {this.currency ? <span>{' ' + this.currency}</span> : null}
        </div>
        {this.note ? <p>{this.note}</p> : null}
        {this.label ? (
          <pn-button id={'pricecta-' + this.linkid} small="true" icon={open_in_new} appearance="light" href={this.url} target="_blank">
            {this.label}
          </pn-button>
        ) : null}
      </Host>
    ) : (
      <Host>
        <div class="price">
          {this.amount ? <span>{this.amount}</span> : null}
          {this.currency ? <span>{this.currency}</span> : null}
        </div>
      </Host>
    );
  }
}
